import React, { useState, useEffect } from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import Image from "next/image";
import Link from "next/link";
import Event1 from "@/public/static/images/event-c-01.png";
import Event2 from "@/public/static/images/event-c-02.png";
import Event3 from "@/public/static/images/event-c-03.png";
import Event4 from "@/public/static/images/event-c-04.png";
import Event5 from "@/public/static/images/event-c-05.png";

import EventPJ1 from "@/public/static/images/event-pj-01.png";
import EventPJ2 from "@/public/static/images/event-pj-02.png";
import EventPJ3 from "@/public/static/images/event-pj-03.png";
import EventPJ4 from "@/public/static/images/event-pj-04.png";
import EventPJ5 from "@/public/static/images/event-pj-05.jpg";
import EventPJ6 from "@/public/static/images/event-pj-06.jpg";

import bgPa from "@/public/static/images/event-bg.png";

import DemoIMG from "@/public/static/images/demo_img.png";

function event_activation() {
  const img: any = "/static/images/s-event.png";

  const imgAnimation = UseAnimation();

  const handleMouseMove = (e: any) => {
    const { clientX, clientY } = e;
    const moveX = clientX - window.innerWidth / 2;
    const moveY = clientY - window.innerHeight / 2;
    const offsetFactor = 15;
    imgAnimation.start({
      x: moveX / offsetFactor,
      y: moveY / offsetFactor,
    });
  };

  return (
    <div className="wrapper">
      <Header />
      <section className="key_visual">
        <motion.img
          // animate={imgAnimation}
          // onMouseMove={(e) => handleMouseMove(e)}
          src={img}
          alt="Event Activation"
          loading="lazy"
        />
        <div className="img-bg" />
      </section>

      <section className="sv_content event-content">
        <div className="container">
          <div className="row">
            <div className="col-12 heading-top_content">
              <div className="d-flex justify-content-center">
                <h2>Event & Activation</h2>
              </div>
            </div>
            <div className="col-12 sv_content-inner">
              <p>
                As a company that manages customers' "information", ITP Asia has
                more than 100 years of experience.
              </p>
              <p>
                Based on our experience, ITP Asia has always considered what is
                the best activity that can connect customers and end users.
              </p>
              <p className="mb-4">
                So, we help with everything from brand recognition proposals,
                such as booth planning and management at large-scale
                exhibitions, to delivering Customer Experience (UX) with
                "Activation" whether in shopping malls, convenience stores, or
                local facilities.
              </p>
              <p className="mb-4">
                ITP Asia's digital marketing technology will also turn all of
                these activities into fulfilling content.
              </p>
              <ul>
                <li>International Exhibition</li>
                <li>Ceremony (Opening Ceremony, Anniversary Ceremony)</li>
                <li>Test driving</li>
                <li>Activation (Testing event, Product Sample event)</li>
                <li>Seminar</li>
                <li>Private event</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center ev-heading-spr">
              <h1 className="fw-bold">
                Though digitalization take a big part in our everyday life,
              </h1>
              <h1 className="fw-bolder t-green">
                Offline Event and Activation still should not be overlooked
              </h1>
              <h1>
                as it is a tool to complement your digital strategies and
                advantage your business
              </h1>
            </div>
          </div>
          <div className="row justify-content-md-center mt-5">
            <div className="col-12 col-md-4 card-sv card-event">
              <div className="card h-100 text-center">
                <Image
                  loading="lazy"
                  src={Event1}
                  alt="Face to Face Interaction"
                  className="img-fluid mx-auto"
                />
                <div className="card-body">
                  <h2 className="card-title t-green">
                    Face to Face Interaction
                  </h2>
                  <p>
                    Build trust and rapport, showcase products and services in
                    face to face opportunity from an offline event.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-event">
              <div className="card h-100 text-center">
                <Image
                  loading="lazy"
                  src={Event2}
                  alt="Brand Awareness"
                  className="img-fluid mx-auto"
                />
                <div className="card-body">
                  <h2 className="card-title t-green">Brand Awareness</h2>
                  <p>
                    Increase brand awareness, be visible, and reach more
                    audience by hosting a memorable offline event{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-md-center mb-5">
            <div className="col-12 col-md-4 card-sv card-event">
              <div className="card h-100 text-center">
                <Image
                  loading="lazy"
                  src={Event3}
                  alt="Networking Opportunities"
                  className="img-fluid mx-auto"
                />
                <div className="card-body">
                  <h2 className="card-title t-green">
                    Networking Opportunities
                  </h2>
                  <p>
                    Have new networking opportunities for businesses with
                    potential partners, customers, and industry experts through
                    offline events
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-event">
              <div className="card h-100 text-center">
                <Image
                  loading="lazy"
                  src={Event4}
                  alt="Emotional Connection"
                  className="img-fluid mx-auto"
                />
                <div className="card-body">
                  <h2 className="card-title t-green">Emotional Connection</h2>
                  <p>
                    create a stronger emotional connection with attendees and
                    foster loyalty and advocacy to your brand
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-event">
              <div className="card h-100 text-center">
                <Image
                  loading="lazy"
                  src={Event5}
                  alt="Unique Experience"
                  className="img-fluid mx-auto"
                />
                <div className="card-body">
                  <h2 className="card-title t-green">Unique Experience</h2>
                  <p>
                    Offer a unique experience, let your brand stand out, and
                    create a lasting impression on attendees
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center ev-heading-spr_bl mb-5">
              <h1 className="fw-bolder t-green">
                More than 50 projects we managed
                <br />
                prove our experience
              </h1>
              <h2 className="t-white">
                Here are what we provide full-service support for our clients
              </h2>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={EventPJ1}
                  alt="Exhibition / Booth / Fair"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body">
                  <h1 className="t-green">Exhibition / Booth / Showroom</h1>
                  <ul className="t-white">
                    <li>Conceptualize theme</li>
                    <li>Plan the layout and design the booth</li>
                    <li>Develop marketing plan to PR</li>
                    <li>Coordinate logistics and related parties</li>
                    <li>Organize staffs</li>
                    <li>Evaluate and follow up</li>
                  </ul>
                </div>
                <div className="card-footer t-white">
                  <h3>
                    Impress your audience and drive success to every of your
                    exhibition with our well-planned, full-organized, and
                    professional-service event team.
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={EventPJ2}
                  alt="Ceremony"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body">
                  <h1 className="t-green">Ceremony</h1>
                  <ul className="t-white">
                    <li>Award Ceremonies</li>
                    <li>Retirement Ceremonies</li>
                    <li>Product Launch Ceremonies</li>
                    <li>Ground Breaking Ceremonies</li>
                    <li>Partnership Ceremonies</li>
                    <li>Annual General Ceremonies</li>
                  </ul>
                </div>
                <div className="card-footer t-white">
                  <h3>
                    Cerebrate your company’s special time with a perfect
                    ceremony. Leave all the details to us and experience an
                    unforgettable moment by our meticulous service.
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={EventPJ3}
                  alt="Test Driving Event"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body">
                  <h1 className="t-green">Test Driving Event</h1>
                  <ul className="">
                    <li>Determine the location</li>
                    <li>Plan the driving route</li>
                    <li>Prioritize safety</li>
                    <li>Develop a marketing plan</li>
                    <li>Deliver attendees the best experience</li>
                  </ul>
                </div>
                <div className="card-footer">
                  <h3>
                    Trusted by leading vehicle companies, we specialize in
                    organizing vehicle test with our skilled team. We have a
                    full experience in managing both statics and dynamics
                    comparison test for vehicles.
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={EventPJ5}
                  alt="Activation"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body">
                  <h1 className="t-green">Activation</h1>
                  <ul className="">
                    <li>Create interactive events</li>
                    <li>Launch pop-up shops</li>
                    <li>Demonstrate products</li>
                    <li>Plan experiential marketing campaigns</li>
                  </ul>
                </div>
                <div className="card-footer">
                  <h3>
                    Grasp the opportunity to strengthen brand image by
                    interacting with consumers through activation. We support
                    you from strategy planning, creative activities development,
                    to ensuring the best experience of audience and achieving
                    your goal.
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={EventPJ6}
                  alt="Exhibition / Booth / Fair"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body">
                  <h1 className="t-green">Seminar</h1>
                  <ul className="t-white">
                    <li>Set the goals and objectives</li>
                    <li>Plan the activities</li>
                    <li>Find the venues and catering</li>
                    <li>Contact the professionals</li>
                    <li>Prepare and run the action plan</li>
                    <li>Coordinate with all involved stakeholders</li>
                  </ul>
                </div>
                <div className="card-footer t-white">
                  <h3>
                    Strengthen your connections with clients and build the brand
                    professional image by launching a seminar with all-rounded
                    support by us. Let your seminar run, let us be your force.{" "}
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={EventPJ4}
                  alt="Private Event"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3 port-service">
              <div className="card h-100">
                <div className="card-body">
                  <h1 className="t-green">Private Event</h1>
                  <ul className="t-white">
                    <li>Corporate Retreats</li>
                    <li>Product Launches</li>
                    <li>Investor Meetings</li>
                    <li>Customer Appreciation Events</li>
                    <li>Executive Dinners</li>
                    <li>Employee Recognitions Events</li>
                    <li>Board Meetings</li>
                  </ul>
                </div>
                <div className="card-footer t-white">
                  <h3>
                    Make your exclusive event memorable by letting us manage all
                    task for you. No matter what private events you have in your
                    plan, we provide you a full service from ideation to
                    execution.
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content sv-inner-parallax gray-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center ev-heading-spr">
              <h1 className="fw-bold t-green">
                We understand how complicated it is to handle all event-related
                job.
              </h1>
              <h1 className="fw-bolder">
                But with our experience
                <br />
                in event planning, managing, and organizing,
              </h1>
              <h2>
                you can just leave all the detailed tasks to us,
                <br />
                and enjoy the successful outcomes of every event execution.
              </h2>
            </div>
          </div>
        </div>
      </section>

      <section className="sv-content_parallax event-bg_footer">
        <div className="container-fluid ">
          <div className="row p-0">
            <Image
              loading="lazy"
              src={bgPa}
              alt="Private Event"
              className="img-fluid mx-auto p-0"
            />
          </div>
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-md-5 ev-content-footer text-center">
              <div className="card h-100">
                <h1 className="t-green">Why with us?</h1>
                <h2>From Zero to Hero:</h2>
                <h3>
                  we offer the best for your goals, impress your audience, and
                  drive desirable outcomes.
                </h3>
              </div>
            </div>
            <div className="col-12 col-md-7 ev-content-footer">
              <div className="card h-100">
                <div className="ev-content-footer_box mb-3">
                  <h1 className="t-green">
                    <span className="badge  rounded-circle">1</span>
                    Brand Recognition Proposal
                  </h1>
                  <p>
                    From very start, we provide all you need from our
                    <span className="fw-bold"> Brand Recognition Proposal</span>
                  </p>
                  <ul>
                    <li>Idea conceptualized</li>
                    <li>Space planning and managing</li>
                    <li>Booth design and decoration</li>
                    <li>Many more that concerned</li>
                  </ul>
                </div>

                <div className="ev-content-footer_box mb-3">
                  <h1 className="t-green">
                    <span className="badge  rounded-circle">2</span>
                    All-Rounded Support
                  </h1>
                  <p>
                    With our experienced team of Event Planning specialists,
                    whether you think of it or not, we cover them ALL from
                    pre-event, on-event and post-event.
                  </p>
                </div>

                <div className="ev-content-footer_box mb-3">
                  <h1 className="t-green">
                    <span className="badge  rounded-circle">3</span>
                    Customer Experience is our priority
                  </h1>
                  <p>
                    Delivering a unique experience is the key of event
                    execution.We pay attention to every details to create the
                    most memorable experience for your customer, which will last
                    a positive vibes on your brand.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content sv-inner-parallax gray-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center ev-heading-spr">
              <h1 className="t-80 fw-bolder mb-3">
                Ready to plan your next event?
              </h1>
              <h2 className="t-60">
                Do not waste your value time by contacting us now
                <br />
                and let us know what you need!
              </h2>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default event_activation;
